class ContentAutor extends HTMLElement {
  connectedCallback() {
    this.setElements();
    this.bindEvents();
    setTimeout(() => this.calculateInitialState(), 100);
  }

  setElements() {
    this.textBoxElem = this.querySelector(".content-autor-toggle-box");
    this.textBoxHeight = this.textBoxElem.clientHeight;
    this.overflowElem = this.querySelector(".content-autor-overflow");
    this.buttonElem = this.querySelector(".content-autor-toggle");
    this.headlineElem = this.querySelector(".content-autor-headline");
    this.subHeadlineElem = this.querySelector(".content-autor-subline");
    this.textElem = this.querySelector(".content-autor-text");
  }

  bindEvents() {
    this.buttonElem.addEventListener('click', (event) => {
      this.toggleText(event);
    });
    window.addEventListener('resize', () => this.calculateInitialState());
  }

  toggleText(event) {
    this.textBoxElem.style.maxHeight = event.target.dataset.state === "more"
      ? `${this.textBoxElem.scrollHeight}px`
      : `${this.textBoxHeight}px`;
    event.target.setAttribute(
      "data-state",
      event.target.dataset.state === "more" ? "less" : "more"
    );
    event.target.innerHTML = event.target.dataset.state === "more" ? "Weiterlesen" : "Weniger";
    this.overflowElem.setAttribute(
      "data-state",
      event.target.dataset.state === "more" ? "visible" : "hidden"
    );
  }

  calculateInitialState() {
    const offset = 5;

    if (this.textBoxElem.offsetHeight + offset < this.textBoxElem.scrollHeight) {
      this.buttonElem.style.display = 'block';
      this.overflowElem.setAttribute("data-state", "visible");
    } else {
      this.buttonElem.style.display = 'none';
      this.overflowElem.setAttribute("data-state", "hidden");
    }
  }
}

if (!customElements.get("content-autor")) {
  customElements.define("content-autor", ContentAutor);
}
